// WAF 反调试测试与控制页：QA 自测用，展示实时时钟观察反调试卡死效果，并可切换 WafSDK/反调试开关
export default {
  path: '/waf/anti-debug',
  name: 'wafAntiDebug',
  component: () => import(/* webpackChunkName: 'waf-anti-debug' */ '@/pages/waf/antiDebug/index.vue'),
  meta: {
    requireAuth: false,
    hiddenNav: true
  }
};
